module.exports = __webpack_public_path__ + "img/8_f.bc9aab3b.jpg";